import * as React from 'react';
import { QuestionProps, Question } from '../../interfaces';

export class LabelRadio extends React.Component<any> {
    public render() {

        var checked = 'radio option';
        if (this.props.option.checked) {
            checked += ' checked';
        }

        return (
            <div className={checked} onClick={this.radioChangeSet()}>
                <label>
                    <input type="radio" name={this.props.buttonGroupId} />
                    {this.props.option.text || '&nbsp;'}
                </label>
            </div>);
    }

    private radioChange() {
        this.props.callback();
        this.props.option.checked = !this.props.option.checked;
    }

    private radioChangeSet(): ((event: any) => void) {
        return this.radioChange.bind(this);
    }
}

export class BinaryQuestion extends React.Component<QuestionProps> implements Question {
    public render() {
        const buttonGroupId = `radioOptions${this.props.question.id}`;

        var options: any[] = [];
        this.props.question.questionOptions.map((opt: any, ind: number) => {
            options.push(<LabelRadio key={opt.id} buttonGroupId={buttonGroupId} option={opt} callback={this.resetOptionsCB()} />);
            if (this.props.question.visualStyle === 'eitherOr' && ind !== this.props.question.questionOptions.length - 1) {
                options.push(<div key={`div- ${opt.id}`}>Or</div>);
            }
        });

        return (
            <div className="binary-question-wrapper question">
                <div className="statement-number">Statement #{this.props.questionNumber}</div>
                <h2>{this.props.question.text}</h2>
                <hr />
                <div className={`options ${this.props.question.visualStyle}`}>
                    {options}
                </div>
            </div>);
    }

    private resetOptions() {
        this.props.question.questionOptions.map((opt: any) => {
            opt.checked = false;
        });
        this.forceUpdate();
    }

    private resetOptionsCB() {
        return this.resetOptions.bind(this);
    }
}


// WEBPACK FOOTER //
// ./src/components/assessment/BinaryQuestion.tsx